import { render, staticRenderFns } from "./UnifiedSearch.vue?vue&type=template&id=4c57de83&scoped=true"
import script from "./UnifiedSearch.vue?vue&type=script&lang=ts"
export * from "./UnifiedSearch.vue?vue&type=script&lang=ts"
import style0 from "./UnifiedSearch.vue?vue&type=style&index=0&id=4c57de83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57de83",
  null
  
)

export default component.exports